/**
 * bb-browse-mega.js — BROWSE mega menu rail/pane switching.
 * Hovering or focusing a left-rail parent link reveals its pane on the right.
 * Clicking a rail link still navigates to that parent collection. No deps.
 */
function init() {
  if (typeof document === 'undefined') return;
  for (const browse of document.querySelectorAll('.bb-browse')) {
    // A11y: Escape closes the open mega and returns focus to its summary so a
    // keyboard user is never trapped in the viewport-spanning disclosure. Wired
    // BEFORE the rail/panes guard so it works even on an empty menu.
    // `.bb-browse` is the <details>; the keydown bubbles up from focused children.
    browse.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !browse.open) return;
      browse.removeAttribute('open');
      const summary = browse.querySelector('summary');
      if (summary) summary.focus();
    });

    const railItems = browse.querySelectorAll('.bb-browse__rail-item');
    const panes = browse.querySelectorAll('.bb-browse__pane');
    if (!railItems.length || !panes.length) continue;

    const activate = (id) => {
      for (const r of railItems) r.classList.toggle('is-active', r.dataset.megaTarget === id);
      for (const p of panes) p.classList.toggle('is-active', p.dataset.megaPane === id);
    };

    for (const item of railItems) {
      const act = () => activate(item.dataset.megaTarget);
      item.addEventListener('pointerenter', act);
      item.addEventListener('focus', act);
    }
  }
}

init();
